import { AntTable } from "./styles";

export default AntTable;
